/*
 * /attachments/$patientId (page)
 */
import { Card, CardContent, CardHeader, CardTitle, Container, Page, Placeholder } from "@emr/react-ui"
import { createFileRoute } from "@tanstack/react-router"
import { trpc } from "../../trpc"
import { PatientAttachmentList } from "../../features/file-attachment/patient-attachment-list"
import { PatientHeader } from "../../features/patient/patient-header"
import type { Patient } from "@emr/db/client"

export const Route = createFileRoute("/attachments/$patientId")({
	component: AttachmentsPage,
})

const MOCK_PATIENT: Partial<Patient> = {
	firstName: "...",
	lastName: "",
	dateOfBirth: null,
	bloodType: null,
	allergies: null,
	emergencyContactName: null,
	emergencyContactPhone: null,
}

function AttachmentsPage() {
	const { patientId } = Route.useParams()

	const { data: patient, isLoading: patientLoading } =
		trpc.patient.getByFilter.useQuery({ where: { id: patientId } })

	const { data: attachmentsData, isLoading: attachmentsLoading } =
		trpc.fileAttachment.getAllByFilter.useQuery({
			where: { patientId, active: true },
		})
	const attachments = attachmentsData ?? []

	const displayPatient = patient ?? (MOCK_PATIENT as Patient)
	const isLoading = patientLoading || attachmentsLoading

	return (
		<Page centerVertical={false}>
			<PatientHeader patient={displayPatient} patientId={patientId} isDirty={false} />
			<Container width="xl" padding="lg" gap="lg">
				{isLoading ? (
					<Placeholder title="Loading..." />
				) : (
					<Card>
						<CardHeader>
							<CardTitle>Attachments</CardTitle>
						</CardHeader>
						<CardContent>
							<PatientAttachmentList patientId={patientId} attachments={attachments} />
						</CardContent>
					</Card>
				)}
			</Container>
		</Page>
	)
}
